import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectTags extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      tagable_type: props.tagable_type,
      tags: props.tags,
      default_options: props.default_options,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectTags() {
    let debounceTimer;
    const account = this.state.account;
    const tagable_type = this.state.tagable_type;
    const tags = this.state.tags;
    const default_options = this.state.default_options;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        tags: value
      });
      let result = value.map((tag) => tag.id);
      document.getElementById('tag_ids').value = JSON.stringify(result);
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/tags/select?search=${value}&tagable_type=${tagable_type}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if ((!tags || tags.length === 0) && (!default_options || default_options.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_options: options });
        });
      }
    };

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_options}
        isMulti
        placeholder={"Select tags..."}
        value={tags}
        getOptionLabel={c => c.title}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        styles={{
          valueContainer: (base) => ({ ...base, minHeight: '40px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectTags()}
      </div>
    );
  }
}

SelectTags.propTypes = {
  account: PropTypes.object,
  tagable_type: PropTypes.string,
  tags: PropTypes.array,
  default_options: PropTypes.array,
};

export default SelectTags;
